module.exports = ".gif {\r\n    width: 250px;\r\n    height: 175px;\r\n}"